import { InstallTypeId } from "../enum";

export const APPLY_IN_GUIDE_VIEW_CONFIG_KEYS: Partial<Record<InstallTypeId, string>> = {
    [InstallTypeId.Parts]: 'InstTypeParts',
    [InstallTypeId.PartsAndSmarts]: 'InstTypePartsAndSmarts',
    [InstallTypeId.SoftTurnkeySelfPerform]: 'InstTypeSoftTurSelfPerform',
    [InstallTypeId.SoftTurnkeySubcontract]: 'InstTypeSoftTurSubcontract',
    [InstallTypeId.TurnkeySelfPerform]: 'InstTypeTurnkeySelfPerform',
    [InstallTypeId.TurnkeySubcontract]: 'InstTypeTurnkeySubcontract',
    [InstallTypeId.UserDefined]: 'InstTypeUserDefined'
};